/**
 * Coerce empty or whitespace-only strings to `undefined`, leaving other values
 * unchanged.
 *
 * @param {unknown} input
 * @returns {unknown}
 * @example
 *
 * ```js
 * coerceEmptyStringToUndefined("") // undefined
 * coerceEmptyStringToUndefined("  ") // undefined
 * coerceEmptyStringToUndefined("hello") // "hello"
 * coerceEmptyStringToUndefined(0) // 0
 * ```
 */
export function coerceEmptyStringToUndefined(input) {
  switch (typeof input) {
    case "string":
      return input.trim() || undefined;
    default:
      return input;
  }
}

/**
 * Coerce `null` (and `undefined`) to `undefined`, preserving all other values.
 *
 * @template T
 * @param {T | null | undefined} [input]
 * @returns {T | undefined}
 * @example
 *
 * ```js
 * coerceNullToUndefined(null) // undefined
 * coerceNullToUndefined(undefined) // undefined
 * coerceNullToUndefined(42) // 42
 * ```
 */
export function coerceNullToUndefined(input) {
  return input ?? undefined;
}
